<template>
	<div style="width:100%">
		<slot name="target"/>
		<mounting-portal
			v-if="internalShow"
			mountTo="#popover-portal"
			append
			multiple
		>
			<t-card
				ref="popover"
				:style="popoverBBox"
				tabindex="0"
				class="popover"
				:elevation="elevation"
			>
				<slot/>
			</t-card>
		</mounting-portal>
	</div>
</template>

<script>
import TCard from '../layers/TCard';
import popoverMixin from './popoverMixin';
export default {
	name: 'TPopover',
	components: { TCard },
	mixins: [popoverMixin],
	props: {
		closeOnClick: Boolean,
		closeOnRightClick: Boolean,
		animate: Boolean,
		disabled: Boolean,
		showPopover: {
			type: Boolean,
			default: false,
		},
		position: {
			type: String,
			default: 'bottom',
		},
		anchor: {
			type: String,
			default: 'right',
		},
		marginY: {
			type: Number,
			default: 5,
		},
		marginX: {
			type: Number,
			default: 5,
		},
		width: {
			type: Number,
			default: 0
		},
		minWidth: {
			type: Number,
			default: 0
		},
		height: {
			type: Number,
			default: 0
		},
		minHeight: {
			type: Number,
			default: 0
		},
		relative: {
			type: Boolean,
			default: false
		},
		elevation: {
			type: String,
			default: '3',
		},
	},
	data() {
		return {
			internalShow: false,
			previousFocusedEl: undefined,
			isScrolling: false,
			popoverBBox: {
				top: 'unset',
				left: 'unset',
				width: 'auto',
				height: 'auto',
			},
			positions: {
				left:   [ -1, 0 ],
				right:  [ 1, 0 ],
				top:    [ 0, -1 ],
				bottom: [ 0, 1 ]
			},
		};
	},
	watch: {
		async showPopover(newVal) {
			this.internalShow = newVal;
			await this.$nextTick();
			if (newVal) {
				this.$_handleShowPopover();
				this.$emit('open');
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$slots.target) {
				this.targetEl = this.$slots.target[0].elm;
			}
		});
	},
	created() {
		document.addEventListener('scroll', this.$_negotiateHandlePosition);
		document.addEventListener('click', this.$_handleGlobalClick, false);
		document.addEventListener('contextmenu', this.$_handleGlobalContextMenu, true);
	},
	destroyed() {
		document.removeEventListener('scroll', this.$_negotiateHandlePosition);
		document.removeEventListener('click', this.$_handleGlobalClick, false);
		document.removeEventListener('contextmenu', this.$_handleGlobalContextMenu, true);
	},
	methods: {
		async open({ width = 200, top = 0, left = 0 }) {
			this.internalShow = true;
			await this.$nextTick();
			let { height } = this.$refs.popover.$el.getBoundingClientRect();
			this.popoverBBox = this.$_createPopoverBBox({
				width,
				popoverHeight: height,
				top,
				bottom: top,
				left
			});

			this.$emit('update:showPopover', true);
			this.$emit('open');
		},
		close() {
			this.internalShow = false;
			this.$emit('update:showPopover', false);
			this.$emit('close');
		},
		$_handleShowPopover() {
			let { target } = this.$slots;
			if (target[0] && target[0].elm) {
				let targetEl = target[0].elm;
				let targetRect = targetEl.getBoundingClientRect();
				this.popoverBBox = this.$_createPopoverBBox(targetRect);

				this.$emit('update:showPopover', true);
				this.$emit('open');
			}
		},
		$_handleGlobalClick(event) {
			if (!this.$refs.popover || !this.$refs.popover.$el) return;
			if (this.closeOnClick) this.close();

			let path = event.path || (event.composedPath ? event.composedPath() : undefined);
			let portal = document.querySelector('#popover-portal');
			let isOutsidePopover = path ? path.indexOf(portal) < 0 : !this.portal.contains(event.target);
			let { target } = this.$slots;

			if (target && target[0] && target[0].elm) {
				let isOutsideTarget = path ? path.indexOf(target[0].elm) < 0 : !target[0].elm.contains(event.target);
				if (isOutsidePopover && isOutsideTarget) {
					this.close();
				}
			} else if (isOutsidePopover) {
				this.close();
			}
		},
		$_handleGlobalContextMenu() {
			if (!this.closeOnRightClick) return;
			if (this.internalShow) this.close();
		}
	}
};
</script>


<style lang="scss" scoped>
.popover-enter-active, .popover-leave-active {
	transition: opacity, transform .3s cubic-bezier(0.175, 0.885, 0.320, 1.175);
}
.popover-enter, .popover-leave-to {
	opacity: 0;
	transform: translateY(-1px) scale(.95);
}

.popover {
	outline:none;
	max-width: none;
	max-height: 300px;
	overflow-y: auto;
	position: absolute;
	margin-top: 0;
	z-index: 10000;
	background: white;
	min-height: 32px;
}

</style>


<docs>
## Examples

### Placeholder

```jsx
<div style="display: inline-grid; grid-row-gap: 10px; grid-template-rows: repeat(4, auto);">
	<t-combobox position="bottom"></t-combobox>
	<t-combobox position="top"></t-combobox>
	<t-combobox position="left"></t-combobox>
	<t-combobox position="right"></t-combobox>
</div>
```

### Disabled

```jsx
<t-combobox disabled></t-combobox>
```
</docs>
